import { createFileRoute } from "@tanstack/react-router";
import Auth from "@/pages/Auth";

export const Route = createFileRoute("/auth")({
  head: () => ({
    meta: [
      { title: "Sign In or Create Account | Statlign" },
      { name: "description", content: "Access your Statlign account to unlock AI football predictions and betting insights." },
      { property: "og:title", content: "Sign In or Create Account | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Access your Statlign account to unlock AI football predictions and betting insights." },
      { name: "twitter:title", content: "Sign In or Create Account | Statlign" },
      { name: "twitter:description", content: "Access your Statlign account to unlock AI football predictions and betting insights." },
    ],
  }),
  component: Auth,
});
